import { AiFillApp } from 'api/ai-fill/types';

export const getAIFillAppId = (app: AiFillApp): string | number =>
  app.isDefault === true ? app.defaultAiFillAppIdentifier : app.aiFillAppId;
export const getAIFillAppName = (app: AiFillApp): string =>
  app.aiFillAppConfig.title ?? app.aiFillAppConfig.goal;
